import {SportstypeSpec} from "../types";
import start from "../../icons/softball/start";
import end from "../../icons/softball/end";
import score from "../../icons/softball/score"
import hit from "../../icons/softball/hit"
import error from "../../icons/softball/error"
import homerun from "../../icons/softball/homerun"
import main from "../../icons/softball/main";

const softball: SportstypeSpec = {
  id: 'softball',
  scoreboardType: 'baseball-scoreboard',
  svg: main,
  releaseStage: 'alpha',
  phases: ['pregame', 'inning', 'postgame'],
  events: [
    {
      id: 'start',
      important: true,
      svg: start
    },
    {
      id: 'end',
      important: true,
      svg: end
    },
    {
      id: 'score',
      important: true,
      svg: score,
      team: 'any'
    },
    {
      id: 'hit',
      important: true,
      svg: hit,
      team: 'any'
    },
    {
      id: 'homerun',
      important: true,
      svg: homerun,
      team: 'any'
    },
    {
      id: 'error',
      important: true,
      svg: error,
      team: 'any'
    }
  ]
}

export default softball
